<template>
  <div v-if="displayFilter" class="alert alert-secondary text-dark mb-0" role="alert">
    <p class="my-0">
      <strong>Filters:</strong> {{ displayFilter }} <button class="btn btn-sm btn-link text-info pl-0" @click="clearFilter">Clear filters</button>
    </p>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'FilterDisplay',
  props: {
    filter: Object,
    filterTypes: Array
  },
  methods: {
    clearFilter() {
      this.$emit('clearFilter');
    }
  },
  computed: {
    displayFilter() {
      if (!this.filter) {
        return null;
      }

      let display = [];
      let filterKeys = Object.keys(this.filter);
      for (let index = 0; index < filterKeys.length; index++) {
        const key = filterKeys[index];
        let value = this.filter[key];
        if (moment(value, moment.ISO_8601, true).isValid()) {
          value = this.$options.filters.prettyDate(value);
        }
        display.push(`${this.filterDisplayMap[key]} ${value}`);
      }

      return display.join(', ')
    },
    filterDisplayMap() {
      let map = {};

      for (let index = 0; index < this.filterTypes.length; index++) {
        const filterType = this.filterTypes[index];
        filterType.subFilters.forEach(subFilter => {
          map[subFilter.key] = `${filterType.label} ${subFilter.label}`;
        });
      }

      return map;
    }
  }
}
</script>
